(function() {

  function initTabs() {
    const tabBar = document.querySelector('.anchor-tabs');
    const sections = document.querySelectorAll('.tab-section');
    if (!tabBar || !sections.length) return;

    const tabs = tabBar.querySelectorAll('.tab-btn');
    const scrollContainer = document.scrollingElement || document.documentElement;
    const header = document.querySelector('store-header.header, .header, header');

    const firstContentMap = new Map();
    sections.forEach(section => {
      firstContentMap.set(section.id, section.querySelector('h2, p, ul, img') || section);
      section.setAttribute('role', 'tabpanel');
    });

    tabs.forEach(tab => {
      const sectionId = tab.getAttribute('href').substring(1);
      tab.setAttribute('aria-controls', sectionId);
    });

    function updatePositions() {
      const headerHeight = header ? header.offsetHeight : 0;
      tabBar.style.top = headerHeight + 'px';
      sections.forEach(s =>
        s.style.scrollMarginTop = (headerHeight + tabBar.offsetHeight + 5) + 'px'
      );
      return headerHeight;
    }

    let headerHeight = updatePositions();
    let isScrollingByClick = false;

    function throttle(fn) {
      let ticking = false;
      return function(...args) {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(() => {
            fn.apply(this, args);
            ticking = false;
          });
        }
      };
    }

    function centerTab(tab) {
      const tabRect = tab.getBoundingClientRect();
      const containerRect = tabBar.getBoundingClientRect();
      let offset = tabRect.left - containerRect.left - (containerRect.width / 2) + (tabRect.width / 2);

      const maxScroll = tabBar.scrollWidth - tabBar.clientWidth;
      let scrollLeft = tabBar.scrollLeft + offset;
      scrollLeft = Math.max(0, Math.min(scrollLeft, maxScroll));

      tabBar.scrollTo({ left: scrollLeft, behavior: 'smooth' });
    }

    tabs.forEach(tab => {
      tab.addEventListener('click', e => {
        e.preventDefault();
        const sectionId = tab.getAttribute('href').substring(1);
        const firstContent = firstContentMap.get(sectionId);
        if (!firstContent) return;

        isScrollingByClick = true;
        tabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');

        centerTab(tab);

        let lastTop = -1;
        let attempts = 0;

        function scrollToTarget() {
          attempts++;
          if (attempts > 50) { 
            isScrollingByClick = false; 
            return; 
          }

          const currentHeaderHeight = header ? header.offsetHeight : 0;
          const top = firstContent.getBoundingClientRect().top + scrollContainer.scrollTop - currentHeaderHeight - tabBar.offsetHeight;
          scrollContainer.scrollTo({ top, behavior: 'auto' });

          if (Math.abs(scrollContainer.scrollTop - top) > 0.5 || 
              Math.abs(currentHeaderHeight - headerHeight) > 0.5 || 
              Math.abs(top - lastTop) > 0.5) {
            lastTop = top;
            requestAnimationFrame(scrollToTarget);
          } else {
            isScrollingByClick = false;
          }
        }

        requestAnimationFrame(scrollToTarget);
      });
    });

    function updateActiveTab() {
      if (isScrollingByClick) return;

      let closestSection = sections[0];
      let minDistance = Infinity;
      const offset = headerHeight + tabBar.offsetHeight + 5;

      sections.forEach(section => {
        const firstContent = firstContentMap.get(section.id);
        const rect = firstContent.getBoundingClientRect();
        const distance = Math.abs(rect.top - offset);

        if (distance < minDistance) {
          minDistance = distance;
          closestSection = section;
        }
      });

      tabs.forEach(tab => {
        const isActive = tab.getAttribute('href') === '#' + closestSection.id;
        tab.classList.toggle('active', isActive);
        if (isActive) centerTab(tab);
      });
    }

    window.addEventListener('scroll', throttle(updateActiveTab));

    if (header) {
      const resizeObserver = new ResizeObserver(throttle(() => {
        headerHeight = updatePositions();
        updateActiveTab();
      }));
      resizeObserver.observe(header);
    }

    window.addEventListener('resize', throttle(() => {
      headerHeight = updatePositions();
      updateActiveTab();
    }));

    updateActiveTab();
  }

  function waitForSections() {
    if (document.querySelectorAll('.tab-section').length) {
      initTabs();
      return;
    }

    const observer = new MutationObserver((mutations, obs) => {
      if (document.querySelectorAll('.tab-section').length) {
        initTabs();
        obs.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  waitForSections();


function initShadowTabs() {
  document.querySelectorAll('.shadow-tabs').forEach(tabBlock => {
    const menu = tabBlock.querySelector('.shadow-tabs-menu');
    const tabs = tabBlock.querySelectorAll('.shadow-tab-btn');
    const panels = tabBlock.querySelectorAll('.shadow-panel');
    if (!tabs.length || !panels.length) return;

    const indicator = document.createElement('div');
    indicator.className = 'shadow-tabs-indicator';
    menu.insertBefore(indicator, menu.firstChild);

    function adjustMenuJustify() {
      const totalWidth = Array.from(tabs).reduce((sum, tab) => sum + tab.offsetWidth, 0)
                       + (tabs.length - 1) * parseInt(getComputedStyle(menu).gap || 0);
      if (totalWidth < menu.clientWidth) {
        menu.style.justifyContent = 'center';
      } else {
        menu.style.justifyContent = 'flex-start';
      }
    }

    function updateIndicatorPosition(index) {
      const tab = tabs[index];
      const left = tab.offsetLeft;
      const width = tab.offsetWidth;
      
      indicator.style.left = left + 'px';
      indicator.style.width = width + 'px';
    }

    function scrollActiveTabIntoView(index) {
      const tab = tabs[index];
      const menuRect = menu.getBoundingClientRect();
      const tabRect = tab.getBoundingClientRect();
      let offset = tabRect.left - menuRect.left - (menuRect.width / 2) + (tabRect.width / 2);

      const maxScroll = menu.scrollWidth - menu.clientWidth;
      let scrollLeft = menu.scrollLeft + offset;
      scrollLeft = Math.max(0, Math.min(scrollLeft, maxScroll));

      menu.scrollTo({ left: scrollLeft, behavior: 'smooth' });
    }

    function initTabState() {
      panels.forEach(p => {
        p.classList.remove('active', 'exit');
        p.style.display = 'none';
        p.setAttribute('aria-hidden', 'true');
      });
      
      tabs.forEach(t => {
        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');
      });
      
      let activeIndex = 0;
      for (let i = 0; i < tabs.length; i++) {
        if (tabs[i].classList.contains('active')) {
          activeIndex = i;
          break;
        }
      }
      
      tabs[activeIndex].classList.add('active');
      tabs[activeIndex].setAttribute('aria-selected', 'true');
      panels[activeIndex].style.display = 'block';
      panels[activeIndex].classList.add('active');
      panels[activeIndex].setAttribute('aria-hidden', 'false');
      
      updateIndicatorPosition(activeIndex);
    }

    adjustMenuJustify();
    
    // initTabState();

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', (e) => {
        e.stopPropagation();
        
        panels.forEach(p => {
          p.classList.remove('active', 'exit');
          p.style.display = 'none';
        });

        tabs.forEach(t => {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        
        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');

        panels[index].style.display = 'block';
        panels[index].offsetHeight;
        panels[index].classList.add('active');
        panels[index].setAttribute('aria-hidden', 'false');

        panels.forEach((p, i) => {
          if (i !== index) {
            p.setAttribute('aria-hidden', 'true');
          }
        });

        updateIndicatorPosition(index);

        scrollActiveTabIntoView(index);
      });
    });

    window.addEventListener('resize', () => {
      adjustMenuJustify();
      const activeTab = tabBlock.querySelector('.shadow-tab-btn.active');
      if (activeTab) {
        const activeIndex = Array.from(tabs).indexOf(activeTab);
        updateIndicatorPosition(activeIndex);
      }
    });
  });
}







if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initShadowTabs();
  });
} else {
  initShadowTabs();
}

})();